// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCLFo0jw6GRO6vWSJErj0GplUd5DsiyXXI",
  authDomain: "rentigo-63d93.firebaseapp.com",
  projectId: "rentigo-63d93",
  storageBucket: "rentigo-63d93.firebasestorage.app",
  messagingSenderId: "739329419394",
  appId: "1:739329419394:web:6df1b77e50fd82aae6ec9b",
  measurementId: "G-J39LNJ06KK",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db, analytics };
export default app;
